import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./header.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import equalityFn from 'zustand/shallow';
import { PARTNER_COMMUNITY_URL } from '~/config';
import { deleteSession } from '~/modules/services/authService';
import { headerStore } from '~/modules/stores/headerStore';
import { WireI18n } from '~/modules/stores/i18nStore';
import { publisherStore, selectLogoSetItems, selectPublisher } from '~/modules/stores/publisher/publisherStore';
import { LOGGED_OUT_ROUTE, navigate } from '~/modules/stores/routerStore';
import { selectUserData, userStore } from '~/modules/stores/userStore';
import { generateMediaUrlImage, images } from '~/modules/utilities/assetUtilities';
import { createButtonKeyboardHandler } from '~/modules/utilities/browserUtilities';
import { logoutError } from '~/modules/utilities/errorUtilities';
import { validateUrl } from '~/modules/utilities/schemaUtilities';
class Header extends LightningElement {
  constructor(...args) {
    super(...args);
    this.images = images;
    this.menu = [];
    this.showSubmenu = false;
    this.labels = {};
    this.sharedLabels = {};
    this.userData = void 0;
    this.publisher = void 0;
    this.handleLogout = async () => {
      const result = await deleteSession();
      if (result !== true) {
        logoutError();
        return;
      }
      navigate(LOGGED_OUT_ROUTE);
    };
    this.handleLogoutKeyboard = createButtonKeyboardHandler(this.handleLogout);
  }
  updateUserData(userData) {
    this.userData = userData;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.globalHeader;
    this.sharedLabels = i18n.shared;
  }
  headerStoreCallback({
    menu,
    showSubmenu
  }) {
    this.menu = menu;
    this.showSubmenu = showSubmenu;
  }
  updatePublisher(publisher) {
    this.publisher = publisher;
  }
  get submenuOptions() {
    const selected = this.menu.filter(item => item.active === true);
    if (selected && selected.length > 0) {
      return selected[0].nav;
    }
    return [];
  }
  get publisherLogoUrl() {
    const match = selectLogoSetItems(publisherStore.getState()).find(test => test.logoType === 'Logo');
    if (match && match.mediaId) {
      return generateMediaUrlImage(match.mediaId);
    }
    return images.company;
  }
  get userProfilePhotoUrl() {
    // If we get the profilePhotoUrl from TbID, we just need to use the url that comes in the JWT, without manipulating it
    if (validateUrl(this.userData.profilePhotoUrl)) {
      return this.userData.profilePhotoUrl;
    }
    return `${PARTNER_COMMUNITY_URL}${this.userData.profilePhotoUrl}`.replace('/partners/partners/', '/partners/');
  }
  get appexchangeLink() {
    return 'https://appexchange.salesforce.com';
  }
  get publisherMenuItems() {
    return [{
      name: this.labels.viewCompanyInfo,
      callbackFunction: this.goToPublisher,
      position: 1
    }];
  }
  get userMenuItems() {
    return [{
      name: this.labels.viewProfile,
      position: 1,
      callbackFunction: this.goToProfile
    }, {
      name: this.labels.logOut,
      position: 2,
      callbackFunction: this.handleLogout
    }];
  }
  goToProfile() {
    window.open(`${PARTNER_COMMUNITY_URL}/profileView`, '_blank');
  }
  goToPublisher() {
    navigate('/publisher');
  }
  /*LWC compiler v7.1.3*/
}
/* TODO: find a solution to move the focus from the header to the first child at the main 
container, when the user navigates through the menu with the keyboard. */
Header.delegatesFocus = true;
_registerDecorators(Header, {
  track: {
    userData: 1,
    publisher: 1
  },
  wire: {
    updateUserData: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectUserData
        };
      }
    },
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    headerStoreCallback: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: headerStore,
          selector: ({
            menu,
            showSubmenu
          }) => ({
            menu,
            showSubmenu
          }),
          equalityFn
        };
      }
    },
    updatePublisher: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: publisherStore,
          selector: selectPublisher
        };
      }
    }
  },
  fields: ["images", "menu", "showSubmenu", "labels", "sharedLabels", "handleLogout", "handleLogoutKeyboard"]
});
const __lwc_component_class_internal = _registerComponent(Header, {
  tmpl: _tmpl,
  sel: "appx-header",
  apiVersion: 62
});
export default __lwc_component_class_internal;